const ITEMS = [
    "Process Engineered. Human Optimized.",
    "Human-in-the-Loop Architecture",
    "AI Exception Architecture",
    "The Seamless Digital Handoff",
    "Human Alignment & Behavioral Integration",
    "Lean Six Sigma",
    "WalkMe Builder",
    "MBTI · FIRO · HPI",
];

export default function Marquee() {
    return (
        <div
            data-testid="editorial-marquee-strip"
            className="relative overflow-hidden border-y border-line bg-panel/40 py-5"
        >
            <div className="marquee-track flex w-max items-center">
                {[0, 1].map((group) => (
                    <div key={group} className="flex items-center" aria-hidden={group === 1}>
                        {ITEMS.map((item, i) => (
                            <span key={i} className="flex items-center">
                                <span className="whitespace-nowrap px-7 font-mono text-[11px] uppercase tracking-[0.3em] text-slate-400">
                                    {item}
                                </span>
                                <span className="h-1.5 w-1.5 rotate-45 bg-blaze/80" />
                            </span>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
}
